(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('#test-carousel-{{ section.id }}');
    if (!carousel || typeof Splide === 'undefined') return;

    const splide = new Splide(carousel, {
      type: 'loop',
      perPage: 3,
      gap: '1.5rem',
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 1 }
      }
    });

    splide.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonialSlider(section) {
      var el = section.querySelector('.splide');
      if (!el || typeof Splide === 'undefined') return;

      var perPage = parseInt(el.dataset.perPage, 10) || 3;

      var splide = new Splide(el, {
        type: 'loop',
        perPage: perPage,
        perMove: 1,
        focus: 'center',
        gap: '2rem',
        padding: { left: '5rem', right: '5rem' },
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: true,
          pauseOnFocus: true,
        },
        breakpoints: {
          767: {
            perPage: 1,
            gap: '1rem',
            padding: { left: '2rem', right: '2rem' },
          },
        },
      });

      /* Mount with AutoScroll extension if available */
      if (window.splide && window.splide.Extensions) {
        splide.mount(window.splide.Extensions);
      } else {
        splide.mount();
      }
    }

    /* Init on load */
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.why-testimonials').forEach(initTestimonialSlider);

      /* Scroll-in stagger: animate slides from center outward on first view */
      document.querySelectorAll('.why-testimonials__slider').forEach(function (slider) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setTimeout(function () {
                var slides = slider.querySelectorAll('.splide__slide');
                if (slides.length) {
                  var viewportCenter = window.innerWidth / 2;
                  var sorted = Array.from(slides).map(function (slide) {
                    var rect = slide.getBoundingClientRect();
                    return { slide: slide, distance: Math.abs(rect.left + rect.width / 2 - viewportCenter) };
                  }).sort(function (a, b) { return a.distance - b.distance; });
                  sorted.forEach(function (item, i) { item.slide.style.transitionDelay = (i * 0.08) + 's'; });
                }
                slider.classList.add('is-visible');
              }, 100);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -100px 0px' });
        observer.observe(slider);
      });
    });

    /* Re-init on Shopify section events */
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        var section = e.target;
        if (section.classList.contains('why-testimonials-section') || section.querySelector('.why-testimonials')) {
          initTestimonialSlider(section);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
